<template>
  <div v-if="table_permissions" class="v-datatable-shell h-100">
    <div
      class="ma-0 mb-3 px-3 pt-2 bg-white position-sticky top-0 zindex-5 w-100"
    >
      <div
        class="d-flex align-center justify-space-between w-100"
        :class="$vuetify.breakpoint.mdAndUp ? 'flex-nowrap' : 'flex-wrap'"
      >
        <div
          class="asn-header-title-bar d-flex align-center justify-space-between w-100 w-md-auto mb-2 mb-md-0 flex-shrink-0"
        >
          <div class="asn-title-container flex-grow-1 min-w-0">
            <datatable-detail :table_properties="table_properties" />
          </div>
          <b-button
            v-if="!$vuetify.breakpoint.mdAndUp"
            small
            class="btn--asn-tools d-flex align-center px-3 py-2 ms-2 flex-shrink-0"
            :class="{ 'btn--asn-tools-active': toolBarVisionState }"
            @click="toolBarVisionState = !toolBarVisionState"
            :aria-expanded="toolBarVisionState ? 'true' : 'false'"
            aria-controls="asn-mobile-toolbar"
          >
            <v-icon
              small
              class="me-1"
              :color="toolBarVisionState ? 'white' : 'primary'"
            >
              {{ toolBarVisionState ? "mdi-chevron-up" : "mdi-chevron-down" }}
            </v-icon>
            <span>{{ $t("tools") }}</span>
            <span
              v-if="!toolBarVisionState && activeFiltersCount > 0"
              class="asn-tools-badge ms-1"
            >
              {{ activeFiltersCount }}
            </span>
          </b-button>
        </div>

        <v-expand-transition>
          <div
            v-show="isToolbarVisiable"
            id="asn-mobile-toolbar"
            class="card-toolbar ma-0 pa-0 w-100 w-md-auto flex-md-grow-1 min-w-0"
            :class="{
              ' p-3 rounded-lg mt-2': !$vuetify.breakpoint.mdAndUp,
            }"
          >
            <div
              class="row mx-n1 w-100 align-center justify-content-start justify-content-md-end flex-md-nowrap"
            >
              <template v-if="permissionChecker('calendar_view')">
                <div
                  class="col-6 col-sm-4 col-md-auto px-1 py-1"
                  v-if="viewType === 1"
                >
                  <button
                    @click.prevent="toggleView"
                    class="btn btn-light-primary w-100 d-flex align-center justify-content-center btn-toolbar-action"
                  >
                    <span class="svg-icon me-1">
                      <v-icon size="18">mdi-calendar</v-icon>
                    </span>
                    <span v-if="!$vuetify.breakpoint.mdAndUp">
                      {{ $t("calendar") }}
                    </span>
                  </button>
                </div>

                <div
                  class="col-6 col-sm-4 col-md-auto px-1 py-1"
                  v-if="viewType === 2"
                >
                  <button
                    @click.prevent="toggleView"
                    class="btn btn-light-primary w-100 d-flex align-center justify-content-center btn-toolbar-action"
                  >
                    <span class="svg-icon me-1">
                      <v-icon size="18">mdi-table</v-icon>
                    </span>
                    <span v-if="!$vuetify.breakpoint.mdAndUp">
                      {{ $t("table") }}
                    </span>
                  </button>
                </div>
              </template>

              <div
                class="col-6 col-sm-4 col-md-auto px-1 py-1"
                v-if="permissionChecker('create')"
              >
                <button
                  @click.prevent="showAddItemModal"
                  class="btn btn--export-filter w-100 d-flex align-center justify-content-center btn-toolbar-action"
                >
                  <span class="svg-icon me-1">
                    <v-icon size="18">mdi-plus-box-outline</v-icon>
                  </span>
                  <span>{{ addAsnLabel }}</span>
                </button>
                <AddItem
                  :pageLoader="pageLoad"
                  :refresher="updateTableContent"
                  ref="addItem"
                />
              </div>

              <div
                class="col-6 col-sm-4 col-md-auto px-1 py-1"
                v-if="permissionChecker('upload')"
              >
                <UploadSelectForASN
                  :types="$store.getters.getASNUploadType"
                  :actionFunction="showUploadModal"
                />
              </div>

              <div
                class="col-6 col-sm-4 col-md-auto px-1 py-1"
                v-if="permissionChecker('export') && exportHeaders"
              >
                <button
                  @click="$refs.exportSidebar.$data.exportSidebar = true"
                  class="btn btn--export-filter w-100 d-flex align-center justify-content-center btn-toolbar-action"
                >
                  <span class="svg-icon me-1">
                    <v-icon size="18">mdi-export-variant</v-icon>
                  </span>
                  <span>{{ $t("export") }}</span>
                </button>
              </div>

              <div
                class="col-6 col-sm-4 col-md-auto px-1 py-1"
                v-if="filters.length > 0"
              >
                <button
                  @click="$refs.filterSidebar.$data.filterSidebar = true"
                  class="btn btn--export-filter w-100 d-flex align-center justify-content-center btn-toolbar-action"
                  :class="{ 'btn-filter--active': activeFiltersCount > 0 }"
                >
                  <span class="svg-icon me-1">
                    <v-icon size="18">mdi-filter</v-icon>
                  </span>
                  <span>{{ $t("filter") }}</span>
                  <span
                    v-if="activeFiltersCount > 0"
                    class="badge badge-primary ms-1 px-1 py-0"
                  >
                    {{ activeFiltersCount }}
                  </span>
                </button>
              </div>

              <div
                class="col-6 col-sm-4 col-md-auto px-1 py-1"
                v-if="actionsButtonTypes.length > 0"
              >
                <ActionsButton
                  :items="selected"
                  :types="actionsButtonTypes"
                  :refresher="updateTableContent"
                  :callback="{
                    bulk_update: updateStatus,
                  }"
                />
              </div>
            </div>
          </div>
        </v-expand-transition>
      </div>
    </div>
    <!-- Export Sidebar start -->
    <ExportSidebar
      v-if="permissionChecker('export') && exportHeaders"
      ref="exportSidebar"
      :exportHeaders="exportHeaders"
      :downloadItem="downloadItem"
      :submitFilterValues="submitFilterValues"
      :resetFilterValues="resetFilterValues"
      :filters="filters"
      :setTableFiltersValues="setTableFiltersValues"
    />
    <!--        end::Export Sidebar-->

    <!-- Filter Sidebar start -->
    <FilterSidebar
      v-if="filters.length > 0"
      ref="filterSidebar"
      :submitFilterValues="submitFilterValues"
      :resetFilterValues="resetFilterValues"
      :filters="filters"
      :setTableFiltersValues="setTableFiltersValues"
    />
    <!--end::Filter Sidebar-->

    <Others ref="otherData" :updateDatatable="updateTableContent" />

    <template v-if="viewType === 1">
      <div class="v-datatable-scroll">
        <v-data-table
          v-model="selected"
          :fixed-header="true"
          light
          dense
          height="100%"
          show-select
          :single-select="disableSelectAllCheckbox"
          :items="items"
          :headers="headers"
          :sort-by.sync="orderBy"
          :sort-desc.sync="sortOrder"
          :items-per-page="itemPerPage"
          item-key="id"
          class="mx-2 mt-0 font-weight-bold"
          hide-default-footer
          @dblclick:row="showDetail"
          mobile-breakpoint="40"
        >
          <!--    no-data-->
          <template v-slot:no-data>
            <v-skeleton-loader
              class="mt-10 px-6"
              v-if="Boolean($store?.getters?.getPageLoading)"
              type="card"
            />
            <template v-else>{{ $t("no_data") }}</template>
          </template>
          <template v-slot:no-results>{{ $t("no_results") }}</template>
          <!--    no-data end-->

          <!--      <template v-slot:top>-->
          <!--        <div-->
          <!--          class="ma-0 mb-10 pa-0 pt-2 d-flex justify-space-between align-center flex-wrap bg-white position-sticky top-0 zindex-5"-->
          <!--          :class="{ 'flex-column': $vuetify.breakpoint.xsOnly }"-->
          <!--        >-->
          <!--          <datatable-detail-->
          <!--            :table_properties="table_properties"-->
          <!--            v-if="$vuetify.breakpoint.smAndUp"-->
          <!--          />-->
          <!--          <div-->
          <!--            v-else-->
          <!--            class="d-flex align-center justify-space-between mb-3 w-100"-->
          <!--          >-->
          <!--            <datatable-detail :table_properties="table_properties" />-->
          <!--            <b-button-->
          <!--              v-show="$vuetify.breakpoint.xsOnly"-->
          <!--              depressed-->
          <!--              small-->
          <!--              variant="outline-primary"-->
          <!--              class="px-5 py-3 mb-1 btn&#45;&#45;tools"-->
          <!--              @click="toolBarVisionState = !toolBarVisionState"-->
          <!--            >-->
          <!--              TOOLS-->
          <!--            </b-button>-->
          <!--          </div>-->

          <!--          <div-->
          <!--            v-show="isToolbarVisiable"-->
          <!--            style="display: flex; justify-content: center; align-items: center"-->
          <!--            class="card-toolbar ma-0 pa-0 col-md-8 col-sm-10 col-12 row justify-content-start justify-content-sm-end justify-content-md-end align-center align-content-center"-->
          <!--          >-->
          <!--            <div-->
          <!--              class="mr-md-2 mr-sm-1 mb-1 mr-0 pa-0"-->
          <!--              :class="{ 'col-6 px-8 mt-3': $vuetify.breakpoint.xsOnly }"-->
          <!--              v-if="viewType === 1"-->
          <!--            >-->
          <!--              <button-->
          <!--                @click.prevent="toggleView"-->
          <!--                class="btn btn&#45;&#45;export-filter"-->
          <!--              >-->
          <!--                <span class="svg-icon">-->
          <!--                  <v-icon size="18">mdi-calendar</v-icon>-->
          <!--                </span>-->
          <!--                Calendar View-->
          <!--              </button>-->
          <!--            </div>-->

          <!--            <div-->
          <!--              class="mr-md-2 mr-sm-1 mb-1 mr-0 pa-0"-->
          <!--              :class="{ 'col-6 px-8 mt-3': $vuetify.breakpoint.xsOnly }"-->
          <!--              v-if="viewType === 2"-->
          <!--            >-->
          <!--              <button-->
          <!--                @click.prevent="toggleView"-->
          <!--                class="btn btn&#45;&#45;export-filter"-->
          <!--              >-->
          <!--                <span class="svg-icon">-->
          <!--                  <v-icon size="18">mdi-table</v-icon>-->
          <!--                </span>-->
          <!--                Table View-->
          <!--              </button>-->
          <!--            </div>-->

          <!--            <div-->
          <!--              class="mr-md-2 mr-sm-1 mb-1 mr-0 pa-0"-->
          <!--              :class="{ 'col-6 px-8 mt-3': $vuetify.breakpoint.xsOnly }"-->
          <!--              v-if="permissionChecker('create')"-->
          <!--            >-->
          <!--              <button-->
          <!--                @click.prevent="showAddItemModal"-->
          <!--                class="btn btn&#45;&#45;export-filter"-->
          <!--              >-->
          <!--                <span class="svg-icon">-->
          <!--                  <v-icon size="18">mdi-plus-box-outline</v-icon>-->
          <!--                </span>-->
          <!--                Add {{ table_properties.title }}-->
          <!--              </button>-->
          <!--              <AddItem-->
          <!--                :pageLoader="pageLoad"-->
          <!--                :refresher="updateTableContent"-->
          <!--                ref="addItem"-->
          <!--              />-->
          <!--            </div>-->
          <!--            <div-->
          <!--              class="mr-md-2 mr-sm-1 mb-1 mr-0 pa-0"-->
          <!--              v-if="permissionChecker('update_asn_status')"-->
          <!--            >-->
          <!--              &lt;!&ndash; <button-->
          <!--                class="btn btn&#45;&#45;print-upload w-100"-->
          <!--                @click.prevent="updateStatus(null, true)"-->
          <!--              >-->
          <!--                <span class="svg-icon d-none d-sm-inline-block">-->
          <!--                  <v-icon size="18">mdi-refresh</v-icon>-->
          <!--                </span>-->
          <!--                Update Status-->
          <!--              </button> &ndash;&gt;-->
          <!--              <ChangeStatus-->
          <!--                :refresher="updateTableContent"-->
          <!--                :pageLoader="pageLoad"-->
          <!--                ref="changeStatus"-->
          <!--                :ids="selected"-->
          <!--                :isMultiple="getIsUpdateStatusItemsMultiple"-->
          <!--              />-->
          <!--            </div>-->
          <!--            <UploadSelectForASN-->
          <!--              v-if="permissionChecker('upload')"-->
          <!--              :types="$store.getters.getASNUploadType"-->
          <!--              :actionFunction="showUploadModal"-->
          <!--              :class="{ 'col-6': $vuetify.breakpoint.xsOnly }"-->
          <!--            />-->
          <!--            &lt;!&ndash;begin::Dropdown&ndash;&gt;-->
          <!--            <div-->
          <!--              class="mr-md-2 mr-sm-1 mb-1 mr-0 pa-0"-->
          <!--              :class="{ 'col-6 px-8 mt-3': $vuetify.breakpoint.xsOnly }"-->
          <!--              v-if="permissionChecker('export') && exportHeaders"-->
          <!--            >-->
          <!--              <button-->
          <!--                @click="$refs.exportSidebar.$data.exportSidebar = true"-->
          <!--                class="btn btn&#45;&#45;export-filter"-->
          <!--              >-->
          <!--                <span class="svg-icon">-->
          <!--                  <v-icon size="18">mdi-export-variant</v-icon>-->
          <!--                </span>-->
          <!--                Export-->
          <!--              </button>-->
          <!--            </div>-->

          <!--            &lt;!&ndash;end::Button&ndash;&gt;-->

          <!--            <div-->
          <!--              class="mr-md-2 mr-sm-1 mb-1 mr-0 pa-0"-->
          <!--              :class="{ 'col-6 px-8 mt-3': $vuetify.breakpoint.xsOnly }"-->
          <!--              v-if="filters.length > 0"-->
          <!--            >-->
          <!--              <button-->
          <!--                @click="$refs.filterSidebar.$data.filterSidebar = true"-->
          <!--                class="btn btn&#45;&#45;export-filter"-->
          <!--              >-->
          <!--                <span class="svg-icon">-->
          <!--                  <v-icon size="18">mdi-filter</v-icon>-->
          <!--                </span>-->
          <!--                Filter-->
          <!--              </button>-->
          <!--            </div>-->
          <!--            <div-->
          <!--              class="mr-md-2 mr-sm-1 mb-1 mr-0 pa-0 mt-1"-->
          <!--              :class="{ 'col-6 px-8 mt-3': $vuetify.breakpoint.xsOnly }"-->
          <!--            >-->
          <!--              <ActionsButton-->
          <!--                v-if="actionsButtonTypes.length > 0"-->
          <!--                :items="selected"-->
          <!--                :types="actionsButtonTypes"-->
          <!--                :refresher="updateTableContent"-->
          <!--                :class="{ 'col-6': $vuetify.breakpoint.xsOnly }"-->
          <!--                :callback="{-->
          <!--                  bulk_update: updateStatus,-->
          <!--                }"-->
          <!--              />-->
          <!--            </div>-->

          <!--            &lt;!&ndash;end::Button&ndash;&gt;-->
          <!--          </div>-->
          <!--        </div>-->
          <!--        &lt;!&ndash; Export Sidebar start &ndash;&gt;-->
          <!--        <ExportSidebar-->
          <!--          v-if="permissionChecker('export') && exportHeaders"-->
          <!--          ref="exportSidebar"-->
          <!--          :exportHeaders="exportHeaders"-->
          <!--          :downloadItem="downloadItem"-->
          <!--          :submitFilterValues="submitFilterValues"-->
          <!--          :resetFilterValues="resetFilterValues"-->
          <!--          :filters="filters"-->
          <!--          :setTableFiltersValues="setTableFiltersValues"-->
          <!--        />-->
          <!--        &lt;!&ndash;        end::Export Sidebar&ndash;&gt;-->

          <!--        &lt;!&ndash; Filter Sidebar start &ndash;&gt;-->
          <!--        <FilterSidebar-->
          <!--          v-if="filters.length > 0"-->
          <!--          ref="filterSidebar"-->
          <!--          :submitFilterValues="submitFilterValues"-->
          <!--          :resetFilterValues="resetFilterValues"-->
          <!--          :filters="filters"-->
          <!--          :setTableFiltersValues="setTableFiltersValues"-->
          <!--        />-->
          <!--        &lt;!&ndash;end::Filter Sidebar&ndash;&gt;-->

          <!--        <Others ref="otherData" :updateDatatable="updateTableContent" />-->
          <!--      </template>-->

          <template
            v-if="!disableSelectAllCheckbox"
            v-slot:header.data-table-select="{
              props: { value },
              on: { input },
            }"
          >
            <div
              class="form-check form-check-sm form-check-custom form-check-solid mr-5 min-w-20px min-h-20px"
            >
              <input
                class="form-check-input"
                type="checkbox"
                v-model="allSelected"
                @click="selectAll"
              />
            </div>
          </template>

          <template v-slot:item.data-table-select="{ item }">
            <div
              class="form-check form-check-sm form-check-custom form-check-solid mr-5 min-w-20px min-h-20px"
            >
              <input
                class="form-check-input"
                type="checkbox"
                v-model="selected"
                @click="selectOne"
                :value="item"
              />
            </div>
          </template>
          <template
            v-for="(head, i) in headers"
            v-slot:[`item.`+head.value]="{ item, header, value }"
          >
            <ComponentSelector
              v-bind:key="i"
              :item="item"
              :header="header"
              :value="value"
            />
          </template>

          <template #item.action="{ item }">
            <v-menu left transition="scale-transition" offset-y bottom rounded>
              <template v-slot:activator="{ on, attrs }">
                <a
                  v-bind="attrs"
                  v-on="on"
                  class="btn btn-light-light btn-hover-info show poppins min-w-100px min-w-md-110px"
                >
                  {{ $t("actions") }}
                  <span class="svg-icon svg-icon-5 m-0">
                    <v-icon small>mdi-chevron-down</v-icon>
                  </span>
                </a>
              </template>
              <v-card class="poppins py-1" elevation="1">
                <div v-if="permissionChecker('update')">
                  <v-btn
                    class="w-100 text-left"
                    :disabled="!item.extra_data.detail.actions.update"
                    :class="
                      !item.extra_data.detail.actions.update
                        ? 'text-muted'
                        : 'text-dark'
                    "
                    @click="editItem(item)"
                    text
                    >{{ $t("edit") }}</v-btn
                  >
                </div>
                <!-- <div v-if="permissionChecker('view')">
              <v-btn class="w-100 text-left" @click="showItemDetail(item)" text
                >View</v-btn
              >
            </div> -->
                <div v-if="permissionChecker('view')">
                  <v-btn
                    class="w-100 text-left"
                    :disabled="!item.extra_data.detail.actions.show"
                    :class="
                      !item.extra_data.detail.actions.show
                        ? 'text-muted'
                        : 'text-dark'
                    "
                    @click="() => showItemDetail(item)"
                    text
                    >{{ $t("view") }}</v-btn
                  >
                </div>
                <div v-if="permissionChecker('update')">
                  <v-btn
                    class="w-100 text-left"
                    :disabled="!item.extra_data.detail.actions.close"
                    :class="
                      !item.extra_data.detail.actions.close
                        ? 'text-muted'
                        : 'text-dark'
                    "
                    @click="() => actionClose(item)"
                    text
                    >{{ $t("close") }}</v-btn
                  >
                </div>
                <div v-if="permissionChecker('update')">
                  <v-btn
                    class="w-100 text-left"
                    :disabled="!item.extra_data.detail.actions.cancel"
                    :class="
                      !item.extra_data.detail.actions.cancel
                        ? 'text-muted'
                        : 'text-dark'
                    "
                    @click="() => actionCancel(item)"
                    text
                    >{{ $t("cancel") }}</v-btn
                  >
                </div>

                <div v-if="permissionChecker('destroy')">
                  <v-btn
                    class="w-100 text-left"
                    :disabled="!item.extra_data.detail.actions.delete"
                    :class="
                      !item.extra_data.detail.actions.delete
                        ? 'text-muted'
                        : 'text-dark'
                    "
                    @click="removeItem(item)"
                    text
                    >{{ $t("delete") }}</v-btn
                  >
                </div>
                <div v-if="permissionChecker('export')">
                  <v-btn
                    class="w-100 text-left"
                    :disabled="!item.extra_data.detail.actions.export_skus"
                    :class="
                      !item.extra_data.detail.actions.export_skus
                        ? 'text-muted'
                        : 'text-dark'
                    "
                    @click="() => actionExportSku(item)"
                    text
                    >{{ $t("export_skus") }}</v-btn
                  >
                </div>
                <div v-if="permissionChecker('asn_sync_with_wms')">
                  <v-btn
                    class="w-100 text-left"
                    :disabled="!item.extra_data.detail.actions.repush_to_wms"
                    :class="
                      !item.extra_data.detail.actions.repush_to_wms
                        ? 'text-muted'
                        : 'text-dark'
                    "
                    @click="syncWithWmsAction(item)"
                    text
                    >{{ $t("sync_with_wms") }}</v-btn
                  >
                </div>
                <div v-if="permissionChecker('upload_doc')">
                  <v-btn
                    class="w-100 text-left"
                    :disabled="!item.extra_data.detail.actions.upload_doc"
                    :class="
                      !item.extra_data.detail.actions.upload_doc
                        ? 'text-muted'
                        : 'text-dark'
                    "
                    @click="showUploadDocModal(item)"
                    text
                    >{{ $t("upload_doc") }}</v-btn
                  >
                </div>
                <div v-if="permissionChecker('release')">
                  <v-btn
                    class="w-100 text-left"
                    :disabled="!item.extra_data.detail.actions.release_asn"
                    :class="
                      !item.extra_data.detail.actions.release_asn
                        ? 'text-muted'
                        : 'text-dark'
                    "
                    @click="() => showReleaseModal(item)"
                    text
                    >{{ $t("release") }}</v-btn
                  >
                </div>
                <div v-if="permissionChecker('view')">
                  <v-btn
                    class="w-100 text-left"
                    :disabled="!item.extra_data.detail.actions.import_asn_sku"
                    :class="
                      !item.extra_data.detail.actions.import_asn_sku
                        ? 'text-muted'
                        : 'text-dark'
                    "
                    @click="() => handleImportAction(item)"
                    text
                    >{{ $t("import_asn_sku") }}</v-btn
                  >
                </div>
              </v-card>
            </v-menu>
          </template>
          <!-- column end -->
        </v-data-table>
      </div>
      <div v-if="items.length" class="v-datatable-pagination-row">
        <Pagination
          :setitemPerPage="setitemPerPage"
          :getitemPerPage="getitemPerPage"
          :getpageNumber="getpageNumber"
          :setpageNumber="setpageNumber"
          :totalItems="totalItems"
          :pageCount="pageCount"
          :updateTableContent="updateTableContent"
        />
      </div>
    </template>

    <ASNCalendarView
      v-if="permissionChecker('calendar_view')"
      ref="calendarView"
    />

    <EditItem
      :refresher="updateTableContent"
      :pageLoader="pageLoad"
      :itemForAction="getItemForAction"
      ref="editModal"
    />
    <ReleaseModal
      :pageLoader="pageLoad"
      :refresher="updateTableContent"
      ref="releaseItem"
    />
    <QueueUploadModal
      :refresher="updateTableContent"
      :pageLoader="pageLoad"
      ref="uploadDoc"
      upload_type="asn"
    />
    <ChangeStatus
      v-if="permissionChecker('update_asn_status')"
      :refresher="updateTableContent"
      :pageLoader="pageLoad"
      ref="changeStatus"
      :ids="selected"
      :isMultiple="getIsUpdateStatusItemsMultiple"
    />
  </div>
</template>

<script>
import {
  EXPORT_TABLE_DATA,
  SET_FILTERS_DATA,
  SET_TABLE_FILTER,
  SET_TABLE_PAGE,
  SET_TABLE_PERPAGE,
  SET_TABLE_SORTBY,
  SET_TABLE_SORTORDER,
  UPDATE_TABLE_DATA,
  UPDATE_TABLE_STRUCTURE,
} from "@/core/services/store/asn.module";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import { SET_ITEM_FOR_ACTION } from "@/core/services/store/main.module";
import QueueUploadModal from "@/own/components/Modals/QueueUploadModal";

import ComponentSelector from "@/own/components/datatable/ComponentSelector.vue";
import FilterSidebar from "@/own/components/sidebars/FilterSidebar.vue";
import ExportSidebar from "@/own/components/sidebars/ExportSidebar.vue";
// import Others from "@/own/components/fulfillment/asn/Others.vue";
import Others from "@/own/components/fulfillment/orders/Others.vue";
import AddItem from "@/own/components/fulfillment/asn/AddItem.vue";
import EditItem from "@/own/components/fulfillment/asn/EditItem";
import ReleaseModal from "@/own/components/fulfillment/asn/ReleaseModal.vue";

import Pagination from "@/own/components/pagination/Pagination.vue";
import Swal from "sweetalert2";
import DatatableDetail from "@/own/components/datatable/DatatableDetail";
import ApiService from "@/core/services/api.service";
import getPageWidthHeight from "@/own/mixins/getPageWidthHeight";
import UploadSelectForASN from "@/own/components/UploadSelectForASN.vue";
import ChangeStatus from "@/own/components/fulfillment/asn/ChangeStatus.vue";
import ActionsButton from "@/own/components/fulfillment/asn/ActionsButton";
import ASNCalendarView from "@/own/pages/fulfillment/ASNCalendarView.vue";
export default {
  name: "DataTable",
  mixins: [getPageWidthHeight],
  components: {
    ASNCalendarView,
    ActionsButton,
    DatatableDetail,
    FilterSidebar,
    ExportSidebar,
    Pagination,
    Others,
    AddItem,
    EditItem,
    ComponentSelector,
    UploadSelectForASN,
    QueueUploadModal,
    ChangeStatus,
    ReleaseModal,
  },
  props: {
    disableSelectAllCheckbox: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data: () => ({
    viewType: 1, // 1 - table, 2 - calendar
    toolBarVisionState: false,
    selected: [],
    offset: true,
    columnsModal: false,
    allSelected: false,
    itemForAction: null,
    updateStatusItemId: null,
    isUpdateStatusItemsMultiple: true,
  }),
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
    this.$store.dispatch(UPDATE_TABLE_STRUCTURE, {}).then(() => {});
    this.$store.dispatch(UPDATE_TABLE_DATA, {}).then(() => {});
  },
  beforeCreate() {
    this.$store.commit(SET_PAGE_LOADING, true);
  },
  computed: {
    getIsUpdateStatusItemsMultiple() {
      return this.isUpdateStatusItemsMultiple;
    },
    getItemForAction() {
      return this.itemForAction;
    },
    isToolbarVisiable: function () {
      return this.$vuetify.breakpoint.mdAndUp ? true : this.toolBarVisionState;
    },
    activeFiltersCount() {
      const filters = this.$store.getters.getASNTableState?.filters;
      if (!filters) return 0;
      if (Array.isArray(filters)) {
        return filters.filter(
          (f) =>
            f && f.value !== undefined && f.value !== "" && f.value !== null
        ).length;
      }
      if (typeof filters === "object") {
        return Object.values(filters).filter(
          (val) => val !== "" && val !== null && val !== undefined
        ).length;
      }
      return 0;
    },
    //pagination
    getitemPerPage: function () {
      return this.$store.getters.getASNTableState.per_page;
    },
    getpageNumber: function () {
      return this.$store.getters.getASNTableState.page;
    },
    totalItems: function () {
      return this.$store.getters.getASNTableData.total;
    },
    pageCount: function () {
      return this.$store.getters.getASNTableData.last_page;
    },
    //filters
    filters: function () {
      let filters = null;
      try {
        filters = this.$store.getters.getASNTableFilters;
      } catch {
        filters = [];
      }
      return filters;
    },
    table_permissions: function () {
      if (this.$store.getters.getASNTablePermissions) {
        return this.$store.getters.getASNTablePermissions.map(function (perm) {
          return perm.name;
        });
      } else {
        return false;
      }
    },
    table_properties: function () {
      return this.$store.getters.getASNTableProperties;
    },
    itemPerPage: function () {
      return this.$store.getters.getASNTableState.per_page;
    },
    orderBy: {
      get: function () {
        return this.$store.getters.getASNTableState.sortBy;
      },
      set: function (newValue) {
        if (newValue) {
          this.$store.commit(SET_TABLE_SORTBY, newValue);
          this.$store.dispatch(
            UPDATE_TABLE_DATA,
            this.$store.getters.getASNTableState
          );
        } else {
          this.$store.commit(SET_TABLE_SORTBY, "");
          this.$store.dispatch(
            UPDATE_TABLE_DATA,
            this.$store.getters.getASNTableState
          );
        }
      },
    },
    sortOrder: {
      get: function () {
        let sortOrder = true;
        if (this.$store.getters.getASNTableState.sortOrder === "asc") {
          sortOrder = false;
        }
        return sortOrder;
      },
      set: function (newValue) {
        if (newValue === true) {
          this.$store.commit(SET_TABLE_SORTORDER, "desc");
        } else {
          this.$store.commit(SET_TABLE_SORTORDER, "asc");
        }
        this.$store.dispatch(
          UPDATE_TABLE_DATA,
          this.$store.getters.getASNTableState
        );
      },
    },
    headers: function () {
      let headers = this.$store.getters.getASNTableHeaders.filter(
        (col) => col.visible === true
      );
      headers.forEach((header) => {
        header.class =
          "text-muted fw-bolder font-size-sm text-uppercase poppins-ls";
        header.itemClass = "second-text";
        header.width = undefined;
        if (header.value === "action") {
          header.class =
            "pr-10 text-end text-muted fw-bolder font-size-sm text-uppercase poppins-ls";
        }
      });
      return headers;
    },
    exportHeaders: function () {
      // let headers = this.$store.getters.getASNTableHeaders.filter(
      //   (col) => col.exportable == true
      // );
      // return headers;
      let headers = null;
      try {
        headers = this.$store.getters.getASNTablePermissions
          .find((col) => col.name === "export")
          ?.columns.sort((a, b) => a.order - b.order);
      } catch {
        headers = null;
      }

      return headers;
    },
    items: function () {
      if (this.$store.getters.getASNTableData) {
        return this.$store.getters.getASNTableData.data;
      }
      return [];
    },
    hasSelected: function () {
      return this.selected.length > 0;
    },
    actionsButtonTypes: function () {
      let types = [];

      const typeNames = [
        this.$t("update_status"),
        this.$t("close"),
        this.$t("cancel"),
        this.$t("delete"),
      ];

      const typesUrl = [
        "bulk_update",
        "bulk_close",
        "bulk_cancel",
        "bulk_delete",
      ];

      typesUrl.forEach((item, index) => {
        if (this.permissionChecker(item))
          types.push({
            name: typeNames[index],
            url: item,
          });
      });

      return types;
    },
    addAsnLabel() {
      const title = this.table_properties?.title;
      if (title && typeof title === "string" && title.trim()) {
        return `${this.$t("add")} ${title}`;
      }
      return `${this.$t("add")} ${this.$t("asn")}`;
    },
  },
  methods: {
    toggleView() {
      if (this.viewType === 1) {
        this.$refs?.calendarView?.toggleCalendar();
        this.viewType = 2;
      } else if (this.viewType === 2) {
        this.$refs?.calendarView?.toggleCalendar();
        this.viewType = 1;
      }
    },
    handleImportAction(item) {
      const type = "asn_sku";
      this.$router.push({
        name: "settings.uploads",
        query: {
          type: type,
          asn_number: item.asn_number,
        },
      });
      // this.$refs.upload.toggleUploadModal();
    },
    showUploadDocModal(item) {
      // this.$refs.uploadDoc.$props.itemForAction = item;
      this.$store.commit(SET_ITEM_FOR_ACTION, item);
      this.pageLoad(true);
      this.$refs.uploadDoc.toggleModal();
    },
    showReleaseModal(item) {
      // this.$refs.uploadDoc.$props.itemForAction = item;
      this.$store.commit(SET_ITEM_FOR_ACTION, item);
      setTimeout(() => {
        this.$refs.releaseItem.toggleModal();
      }, 0);
    },
    actionClose(item) {
      this.pageLoad(true);
      ApiService.post("/fulfillment/asn/close", {
        id: item.id,
      })
        .then(() => {
          Swal.fire(
            this.$t("success"),
            this.$t("asn_closed_message"),
            "success"
          );
          this.updateTableContent();
        })
        .catch(() => {
          this.pageLoad(false);
        });
    },
    actionCancel(item) {
      this.pageLoad(true);
      ApiService.post("/fulfillment/asn/cancel", {
        id: item.id,
      })
        .then(() => {
          Swal.fire(
            this.$t("success"),
            this.$t("asn_cancelled_message"),
            "success"
          );
          this.updateTableContent();
        })
        .catch(() => {
          this.pageLoad(false);
        });
    },
    actionExportSku(item) {
      ApiService.post("/fulfillment/asn/export_skus", {
        id: item.id,
      })
        .then((response) => {
          const link = document.createElement("a");
          link.href = response.data.url;
          link.download = "Export.csv";
          link.click();
        })
        .finally();
    },
    removeItem(item) {
      Swal.fire({
        title: this.$t("are_you_sure"),
        text: this.$t("cannot_revert"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("notificationmessage_yes_delete_it"),
      }).then((result) => {
        if (result.isConfirmed) {
          this.pageLoad(true);
          //TODO: change data sending to id
          const data = { id: item.id };
          ApiService.post(`/fulfillment/asn/destroy`, data)
            .then(() => {
              Swal.fire(
                this.$t("notificationtitle_deleted"),
                this.$t("record_has_been_deleted"),
                "success"
              );
              this.updateTableContent();
            })
            .catch(() => {
              this.pageLoad(false);
            });
        }
      });
    },
    syncWithWmsAction(item) {
      this.pageLoad(true);
      ApiService.post(`/fulfillment/asn/sync-to-wms`, { id: item.id })
        .then(() => {
          Swal.fire(
            this.$t("success"),
            this.$t("asn_synced_to_wms_message"),
            "success"
          );
          this.updateTableContent();
        })
        .finally(() => {
          this.pageLoad(false);
        });
    },
    deleteAllItems() {
      this.selected.splice(0, this.selected.length);
      this.allSelected = false;
    },
    selectOne(event) {
      this.allSelected && this.deleteItem(event.target.value);

      this.allSelected = false;
    },
    selectAll(event) {
      this.deleteAllItems();
      if (event.target.checked) {
        this.items.forEach((item) => {
          this.selected.push(item);
        });
      }
    },
    handle_function_call(function_name, prop) {
      this[function_name](prop);
    },
    editItem(item) {
      if (!item.extra_data.detail.actions.update) {
        return;
      }
      this.itemForAction = item.id;
      this.$nextTick(() => {
        this.$refs.editModal.toggleModal();
      });
    },
    // pagination
    setitemPerPage(val) {
      this.$store.commit(SET_TABLE_PERPAGE, val);
      this.$store.commit(SET_TABLE_PAGE, 1);
      this.deleteAllItems();
    },
    setpageNumber(val) {
      this.$store.commit(SET_TABLE_PAGE, val);
      this.deleteAllItems();
    },
    // pagination end
    // filters
    setTableFiltersValues(val) {
      this.$store.commit(SET_TABLE_FILTER, val);
    },
    showUploadModal(type) {
      this.$router.push({
        name: "settings.uploads",
        query: { type: type },
      });
    },
    submitFilterValues() {
      if (this.viewType === 1) {
        this.$store.commit(SET_PAGE_LOADING, true);
        let state = { ...this.$store.getters.getASNTableState };
        state.page = 1;
        this.$store
          .dispatch(UPDATE_TABLE_DATA, state)
          .then(() => {
            this.$store.commit(SET_TABLE_PAGE, 1);
            this.$store.commit(SET_PAGE_LOADING, false);
          })
          .catch((res) => {
            this.$store.commit(SET_PAGE_LOADING, false);
            Swal.fire({
              title: "",
              text: `${res}`,
              icon: "error",
              confirmButtonClass: "btn btn-secondary",
              heightAuto: false,
            });
          });
      } else if (this.viewType === 2) {
        this.$refs?.calendarView?.fetchCalendarData();
      }
    },
    resetFilterValues() {
      this.$store.commit(SET_TABLE_FILTER, []);
      if (this.viewType === 1) {
        this.$store.commit(SET_PAGE_LOADING, true);
        this.$store
          .dispatch(UPDATE_TABLE_DATA, this.$store.getters.getASNTableState)
          .finally(() => {
            this.$store.commit(SET_PAGE_LOADING, false);
          });
      } else if (this.viewType === 2) {
        this.$refs?.calendarView?.fetchCalendarData();
      }
    },
    // filters end
    /**
     * checks permission and return true/false
     * @types {boolean}
     * example "view","create","update","destroy","show","generate","status","print","activate","upload"
     **/
    permissionChecker(permType) {
      return !!this.table_permissions.includes(permType);
    },
    // exports
    downloadItem(columns) {
      this.$store.commit(SET_PAGE_LOADING, true);
      this.export_modal = false;
      this.$store
        .dispatch(EXPORT_TABLE_DATA, {
          columns: columns,
          filters: this.$store.getters.getASNTableState.filters,
        })
        .then(() => {
          const link = document.createElement("a");
          link.href = this.$store.getters.getASNExportUrl;
          link.download = "Export.csv";
          link.click();
          setTimeout(() => {
            this.$store.commit(SET_PAGE_LOADING, false);
          }, 1500);
          this.$refs.exportSidebar.$refs.export.toggleModal();
        });
    },
    // exports end
    showItemDetail(item) {
      this.loadDetailData(item.id);
    },
    showDetail(val, { item }) {
      this.loadDetailData(item.id);
    },
    loadDetailData(id, isEditable = true, toggle = true) {
      this.$store.commit(SET_PAGE_LOADING, true);
      let data = { id: id };
      ApiService.post("/fulfillment/asn/show", data)
        .then((response) => {
          this.$store.commit(SET_PAGE_LOADING, false);

          if (isEditable) {
            this.$refs.otherData.setData(
              response.data.asn,
              id,
              this.loadDetailData,
              "/fulfillment/asn/delete_doc",
              String(id)
            );
          }

          if (toggle) {
            this.$refs.otherData.toggleModal();
          }
        })
        .catch(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },
    pageLoad(state) {
      this.$store.commit(SET_PAGE_LOADING, state);
    },
    showAddItemModal() {
      this.$refs.addItem.toggleModal();
    },
    async updateTableContent() {
      this.pageLoad(true);
      this.selected = [];
      await this.$store
        .dispatch(UPDATE_TABLE_DATA, this.$store.getters.getASNTableState)
        .then(() => {});
      this.$forceUpdate();
      this.pageLoad(false);
    },
    updateStatus() {
      this.$refs.changeStatus.toggleModal();
    },
  },
};
</script>

<style lang="scss">
@media (min-width: 960px) {
  .w-md-auto {
    width: auto !important;
  }
}

.drop-item:hover {
  font-weight: 600;
  background-color: #eee5ff;
  color: #8950fcff !important;
}

.asn-header-title-bar {
  .asn-title-container {
    .card-header {
      width: 100% !important;
      max-width: 100% !important;
      flex: 1 1 auto !important;
    }
    .card-label {
      padding-inline-start: 4px !important;
      padding-left: 4px !important;
    }
  }
}

.btn--asn-tools {
  border: 1px solid #7c3aed !important;
  color: #7c3aed !important;
  background-color: #ffffff !important;
  border-radius: 10px !important;
  font-family: var(--main-font);
  font-weight: 500;
  font-size: 0.95rem;
  min-height: 38px;
  min-width: 96px;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s ease-in-out;
  outline: 0 !important;
  box-shadow: none !important;

  &:hover {
    background-color: rgba(124, 58, 237, 0.08) !important;
    color: #7c3aed !important;
  }
}

.btn--asn-tools-active {
  background: linear-gradient(135deg, #7c3aed 0%, #a855f7 100%) !important;
  color: #ffffff !important;
  border-color: #7c3aed !important;
  box-shadow: 0 2px 8px rgba(124, 58, 237, 0.25) !important;

  &:hover {
    background: linear-gradient(135deg, #6d28d9 0%, #9333ea 100%) !important;
    color: #ffffff !important;
  }
}

.asn-tools-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  font-size: 0.75rem;
  font-weight: 700;
  border-radius: 10px;
  background-color: #7c3aed;
  color: #ffffff;
}

.btn-toolbar-action {
  height: 38px !important;
  min-height: 38px !important;
  border-radius: 10px !important;
  font-size: 0.95rem !important;
  font-weight: 500;
  white-space: nowrap;
}

.btn-filter--active {
  border-color: #7c3aed !important;
  box-shadow: 0 0 0 2px rgba(124, 58, 237, 0.2) !important;
}
</style>
